import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
	Typography,
	IconButton
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { Constants } from 'utilities/constants';

const DeleteModal = ({ classes, module, selectedRows,
	isOpen,
	setIsOpen,
	deleteItems }) => {

	function handleDelete() {
		deleteItems();
	}

	function handleClose(e, reason) {
		if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
		setIsOpen(false);
	}

	function getItemType(isPlural) {
		if (module === Constants.Module.POSTACQ) {
			return isPlural ? 'tasks' : 'task';
		} else {
			return isPlural ? 'transaction opportunities' : 'transaction opportunity';
		}
	}

	return (
		<Dialog onClose={handleClose} open={isOpen} maxWidth='sm' fullWidth>
			<DialogTitle>
				{`Delete ${module === Constants.Module.POSTACQ ? 'Tasks' : 'Transaction Opportunities'}?`}
			</DialogTitle>
			<IconButton className={classes.closeButton} onClick={handleClose}>
				<ClearIcon fontSize="inherit" />
			</IconButton>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<Typography variant='body1' className={classes.caption}>{`${selectedRows.length} ${getItemType(selectedRows.length > 1)} selected.`}</Typography>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleDelete} variant="contained" className={classes.redDialogButton}>Delete</Button>
			</DialogActions>
		</Dialog>
	)
}

const styles = theme => ({
	redDialogButton: {
		color: 'white',
		backgroundColor: theme.palette.red.main,
		'&:hover': {
			backgroundColor: theme.palette.red.dark
		}
	},
	closeButton: {
		position: 'absolute',
		right: 0,
		top: 0,
		backgroundColor: '#ffffff'
	},
});

export default withStyles(styles)(DeleteModal);